// specific to SA
import Component from '../../UM-Base/components/Component';

export default class ModalToInternationalSite extends Component {
	load() {
			let modalDetails = window.localStorage;
			let localStorageModalIsEnabled = modalDetails.getItem("SATCInternationalModalEnabled");
			let modalExpiryDate = modalDetails.getItem("SATCInternationalModalExpiryDate");
			let modalSiteUrlRedirect = modalDetails.getItem("SATCInternationalModalSiteUrl")
			// The expiry date of the user action
			let SATCInternationalModalExpiryPeriod = 10;
			if (modalSiteUrlRedirect != null && modalSiteUrlRedirect.includes("https://") && !window.location.href.includes("nositeredirect")) {
				window.location.href = modalSiteUrlRedirect;
			}

			if (localStorageModalIsEnabled != null && localStorageModalIsEnabled == "true" && (modalExpiryDate != null && !(new Date() > new Date(modalExpiryDate)))) {
				hideModal();
			} else {
				$('.international-modal-container > .modal').modal({ toggle: 'modal', backdrop: 'static', keyboard: false });
			}

			$(".international-modal-container .redirect-to-international-site").on("click", function () {
				let siteUrl = $(this).data("siteredirecturl");
				modalDetails.setItem("SATCInternationalModalEnabled", true);
				modalDetails.setItem("SATCInternationalModalExpiryDate", new Date(new Date().getTime() + (SATCInternationalModalExpiryPeriod * 24 * 60 * 60 * 1000)));
				modalDetails.setItem("SATCInternationalModalSiteUrl", siteUrl);
				window.location.href = siteUrl;
			});

			$(".international-modal-container .dismiss-modal").on("click", function (e) {
				// Set the user choice in the local storage
				modalDetails.setItem("SATCInternationalModalEnabled", true);
				modalDetails.setItem("SATCInternationalModalExpiryDate", new Date(new Date().getTime() + (SATCInternationalModalExpiryPeriod * 24 * 60 * 60 * 1000)));
				hideModal();
			});

			function hideModal() {
				$('.modal').modal("hide");
			}
		super.load();
	}
}
